export const CLIENT_CONFIG_PATH = '/api/portal/v2/client/config';

export const name = 'rnClient';

export default function rnClientProvider() {
  let useBlue = true;

  _.assign(this, {
    useBlueApi,
    $get: rnClient
  });
  return;

  function useBlueApi(doUseBlue = true) {
    useBlue = doUseBlue;
  }

  function rnClient($q, $http, $window, rnBlue) {
    'ngInject';

    const service = {
      getConfig,
    };
    return service;

    function getConfig(cache = true) {
      if (useBlue) {
        return rnBlue.getBlueApi().then(api => {
          return $q.when(api.getClientConfig(cache));
        });
      }

      return $http.get(getHost() + CLIENT_CONFIG_PATH, {
        cache,
        rhino: {
          serviceName: 'portal_service'
        }
      }).then(resp => {
        return resp.data;
      });
    }

    function getHost() {
      // Allow for overriding registry host
      if ($window.RN_SERVICE_REGISTRY) {
        return $window.RN_SERVICE_REGISTRY;
      }

      // Fallback to blue registry host
      let blueRegistryHost = rnBlue.getRegistryHost();
      if (blueRegistryHost) {
        return blueRegistryHost;
      }

      // No registry host configured
      return '';
    }
  }
}
